"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AlertDialogContext = void 0;
var _react = _interopRequireDefault(require("react"));
var AlertDialogContext = exports.AlertDialogContext = /*#__PURE__*/_react.default.createContext();
var _default = exports.default = AlertDialogContext;